import React, { FC, useCallback } from 'react';
import {
  useGetUserNotifications,
  useReadUserNotification,
  useReadUserNotifications,
} from 'api/userNotification.api';
import UserNotificationsPopover from 'components/Header/components/UserNotificationsPopover';
import UserNotificationsContextProvider from 'components/Header/components/UserNotificationsContextProvider';

interface IUserNotificationsContentProvider {
  menuAnchorEl: HTMLElement | null;
  onClose: () => void;
}

const UserNotificationsContentProvider: FC<IUserNotificationsContentProvider> = ({
  menuAnchorEl,
  onClose,
}) => {
  const [readUN, { isLoading: readUNLoading }] = useReadUserNotification();
  const [readUNs, { isLoading: readUNsLoading }] = useReadUserNotifications();
  const { data: unPayload, isLoading: getUNsLoading } = useGetUserNotifications();
  const userNotifications = unPayload?.data || [];

  const readUserNotification = useCallback(
    (notificationId: string, read: boolean): Promise<void> => {
      return readUN({ uuid: notificationId, read })
        .unwrap()
        .catch(() => {});
    },
    [readUN],
  );

  const readUserNotifications = useCallback((): Promise<void> => {
    return readUNs()
      .unwrap()
      .catch(() => {});
  }, [readUNs]);

  return (
    <UserNotificationsContextProvider
      readUserNotification={readUserNotification}
      readUserNotifications={readUserNotifications}
      readUserNotificationLoading={readUNLoading}
      readUserNotificationsLoading={readUNsLoading}
    >
      <UserNotificationsPopover
        userNotifications={userNotifications}
        menuAnchorEl={menuAnchorEl}
        onClose={onClose}
        loading={getUNsLoading}
      />
    </UserNotificationsContextProvider>
  );
};

export default UserNotificationsContentProvider;
